module.exports = __webpack_public_path__ + "assets/electrical-plug-icon.1ce9b0c5.svg";